import { render } from "./index.vue?vue&type=template&id=73a13202"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/templates/campaigns/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "73a13202"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('73a13202', __exports__)) {
    api.reload('73a13202', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=73a13202", () => {
    api.rerender('73a13202', render)
  })

}


export default __exports__